import React from "react";
import { Link } from "react-router-dom";
import "./ServiceCard.scss";
import ProductDefaultImg from "../../../assets/market-icons/producto.jpg";
import CurrencyFormat from "react-currency-format";
import EditIcon from "../../../assets/icons/edit-icon-24px.svg";

const ServiceCard = ({ service }) => {
    let producto = service;
  
    function productName() {
      let name = producto.name;
      if(name.length > 30){
        name = name.substr(0,30)+ "...";
      }
      if(name.indexOf("%") > -1){
        return name.replace("%", "-");
      } else if(name.indexOf("/") > -1){
        return name.replace("/", "-");
      } else {
        return name;
      }
    }
  
    function productImg(){  
      if(!producto.image || producto.image === "null" || producto.image === "N/A"){
        return ProductDefaultImg;
      } else {
        return producto.image;
      }
    }
  
    let originalPrice = producto.sell_price / 100;
  
    let goProduct = () => {
      localStorage.setItem("fk_product", producto.id);
    };
  
    return (
      <div className="card product">
        <img
          src={productImg()}
          className="card-img-top round product"
          alt={"img " + producto.name}
        />
        <div className="card-body">
          <div className="row">
            <h5 className="card-title product">{productName()}</h5>
          </div>
          <div className="row info-card-down">
            <div className="col">
              <div className="row">
                <p 
                  className="card-text product-price" 
                  style={{
                    margin: 0, 
                    fontSize: producto.discount_active ? '0.7rem' : '0.8rem', 
                    textDecoration: producto.discount_active ? 'line-through' : 'none'
                  }}
                >
                  <CurrencyFormat
                    value={originalPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </p>
              </div>
              {producto.discount_active && 
                <div className="row">
                  <p className="card-text product-price">
                    <CurrencyFormat
                      value={producto.discount_price / 100}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                  </p>
                </div>
              } 
            </div>
            <div className="col-5">
              <div className="icon-row">
                <Link
                  className="product-card-icon"
                  to={`/servicios/${producto.id}/edit`}
                  onClick={goProduct}
                > 
                  <img src={EditIcon} alt="edit_icon" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default ServiceCard;
  